import {Component, Inject, OnDestroy, Renderer2, ViewEncapsulation} from '@angular/core';
import Keyboard from 'simple-keyboard';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-virtual-keyboard',
  templateUrl: './virtual-keyboard.component.html',
  styleUrls: ['./virtual-keyboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true
})
export class VirtualKeyboardComponent implements OnDestroy {
  private keyboard!: Keyboard;
  private activeInput: HTMLInputElement | null = null;
  private _enabled = false;
  private observer!: MutationObserver;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly renderer: Renderer2
  ) {
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private setupObserver(): void {
    this.observer = new MutationObserver(() => {
      this.listenToInputs();
    });
    this.observer.observe(this.document.body, {
      childList: true,
      subtree: true
    });
  }

  private initKeyboard() {
    this.keyboard = new Keyboard({
      onChange: (input: string) => {
        if (this.activeInput) {
          this.activeInput.value = input;
          const event = new Event('input', {bubbles: true});
          this.activeInput.dispatchEvent(event);
        }
      },
      onKeyPress: (button: string) => {
        if (button === '{shift}' || button === '{lock}') {
          const layout = this.keyboard.options.layoutName === 'default' ? 'shift' : 'default';
          this.keyboard.setOptions({layoutName: layout});
        }
      },
      theme: 'hg-theme-default myTheme1'
    } as any);
  }

  private listenToInputs() {
    const allInputs = this.document.querySelectorAll('input.vkeyboard');

    allInputs.forEach(input => {
      if ((input as any).__keyboardListenerAttached) return;
      (input as any).__keyboardListenerAttached = true;

      this.renderer.listen(input, 'focus', () => {
        const htmlInput = input as HTMLInputElement;

        if (htmlInput.disabled) {
          this.hideKeyboard();
          return;
        }

        const storedData = localStorage.getItem('authData');
        if (!storedData) {
          return;
        }
         const parsed = JSON.parse(storedData);
          const accessContext = parsed.accessContext;
          const capabilities = parsed.capabilities?.[0];
          const isTerminal = accessContext === 'TERMINAL';
          const keyboardEnabled = isTerminal && capabilities?.onScreenKeyBoard;

          this._enabled = keyboardEnabled;

          if (this._enabled) {
            if (!this.keyboard) {
              this.initKeyboard();
            }
            this.activeInput = htmlInput;
            this.keyboard.setInput(this.activeInput.value || '');
            this.showKeyboard();
          } else {
            this.activeInput = null;
            this.hideKeyboard();
          }
      });
    });
  }

  private showKeyboard() {
    const keyboardContainer = this.document.querySelector('.simple-keyboard') as HTMLElement;
    if (keyboardContainer) keyboardContainer.style.display = 'block';
    this.toggleFooterVisibility(false);
  }

  private hideKeyboard() {
    const keyboardContainer = this.document.querySelector('.simple-keyboard') as HTMLElement;
    if (keyboardContainer) keyboardContainer.style.display = 'none';
    this.toggleFooterVisibility(true);
    this.activeInput = null;
  }

  private toggleFooterVisibility(show: boolean): void {
    const footer = this.document.querySelector('app-footer') as HTMLElement;
    if (footer) {
      footer.style.display = show ? '' : 'none';
    }
  }
}
